export default __webpack_public_path__ + "static/media/fr.05c7984c.svg";